module.exports = {
      id: "ios-usage",
      viewBox: "0 0 114 35",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#ios",
      toString: function () {
        return this.url;
      }
    }